/*
 *
 * ZohoVerify actions
 *
 */
import { VERIFY_ZOHO } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyZoho = {
  start: ({ payload }) => defineAction({ type: VERIFY_ZOHO.START, payload }),
  success: () => defineAction({ type: VERIFY_ZOHO.SUCCESS }),
  error: ({ error }) =>
    defineAction({
      type: VERIFY_ZOHO.ERROR,
      payload: {
        error,
      },
    }),
};
